<template>
  <div class="container">
    <img class="top_bg" src="@/assets/top_bg.png" alt="" />
    <img
      class="welcome_title"
      src="@/assets/welcome_title.png"
      alt=""
      :style="{ top: `calc(0.6rem + ${$store.state.statusBarHeight}px)` }"
    />
    <img class="bottom_bg_left" src="@/assets/bottom_bg_left.png" alt="" />
    <img class="bottom_bg" src="@/assets/before_login_bottom_bg.png" alt="" />
    <div
      class="language_box"
      @click="openLanguagePopup"
      :style="{ top: `calc(0.2rem + ${$store.state.statusBarHeight}px)` }"
    >
      {{ languageNameLocal }}
      <img class="unfold_icon" src="@/assets/unfold_icon.png" alt="" />
    </div>
    <div class="bottom_btn_group">
      <div class="to_input_account_btn" @click="toNext('EMAIL')">
        {{ $t('common.email') }}
        <div v-if="lastLoginType === 'EMAIL'" :class="['last_login_label', $store.state.isMirroring && 'mirror']">
          {{ $t('loginAndRegister.lastLogin') }}
        </div>
      </div>
      <div v-show="phoneShow" @click="toNext('PHONE')" class="to_input_account_btn">
        {{ $t('common.phone') }}
        <div v-if="lastLoginType === 'PHONE'" :class="['last_login_label', $store.state.isMirroring && 'mirror']">
          {{ $t('loginAndRegister.lastLogin') }}
        </div>
      </div>
      <div v-show="moreOptionsShow" @click="moreOptions" class="more_options">
        {{ $t('loginAndRegister.moreOptions') }}
      </div>
      <div class="login_pri">
        <CheckBox :checked="true" :on-change="checkBoxChange">
          <span class="login_pri_info" @click="toProtocolPage">
            <i18n path="loginAndRegister.agreeCheckboxContent" tag="div">
              <span class="green">{{ $t('loginAndRegister.userAgreement') }}</span>
              <span class="green">{{ $t('loginAndRegister.privacyPolicy') }}</span>
            </i18n>
          </span>
        </CheckBox>
      </div>
    </div>
    <LanguagePopup
      :show="showLanguagePopup"
      @closePopup="closeLanguagePopup"
      @changeLanguage="changeLanguage"
    ></LanguagePopup>
  </div>
</template>

<script>
import CheckBox from '@/components/CheckBox'
import LanguagePopup from '@/components/LanguagePopup.vue'
import { Toast } from 'vant'
import { postReportLog } from '../utils/log'

export default {
  name: 'beforeLogin',
  data() {
    return {
      moreOptionsShow: true,
      phoneShow: false,
      license: true,
      lastLoginType: '',
      showLanguagePopup: false,
      languageList: [
        { languageNo: 'en', languageNameLocal: 'English', languageName: 'English' },
        { languageNo: 'hi', languageNameLocal: 'हिन्दी', languageName: 'Hindi' },
        { languageNo: 'ur', languageNameLocal: 'اردو', languageName: 'Urdu' },
        { languageNo: 'ar', languageNameLocal: 'اللغة العربية', languageName: 'Arabic' },
        { languageNo: 'es', languageNameLocal: 'español', languageName: 'Spanish' },
        { languageNo: 'pt', languageNameLocal: 'Português', languageName: 'Portuguese' },
        { languageNo: 'bn', languageNameLocal: 'বাংলা', languageName: 'Bengali' },
        { languageNo: 'fr', languageNameLocal: 'Français', languageName: 'French' },
        { languageNo: 'ru', languageNameLocal: 'Русский', languageName: 'Russian' },
        { languageNo: 'id', languageNameLocal: 'bahasa Indonesia', languageName: 'Indonesian' },
        { languageNo: 'vi', languageNameLocal: 'Tiếng Việt', languageName: 'Vietnamese' },
        { languageNo: 'th', languageNameLocal: 'ภาษาไทย', languageName: 'Thai' },
        { languageNo: 'zh-TW', languageNameLocal: '繁體中文', languageName: 'Chinese Traditional' },
        { languageNo: 'zh-CN', languageNameLocal: '简体中文', languageName: 'Chinese Simplified' },
        { languageNo: 'tr', languageNameLocal: 'Türkçe', languageName: 'Turkish' }
      ],
      curLanguage: ''
    }
  },
  components: {
    CheckBox,
    LanguagePopup
  },
  created() {
    // 已登录用户不应停留在此页（如 OAuth 回调后被重定向回入口），直接跳首页，避免产生埋点噪声
    if (localStorage.getItem('token') && this.$store.state.userInfo && this.$store.state.userInfo.userId) {
      this.$router.replace({ name: 'Home' })
      return
    }
    if (sessionStorage.getItem('acctData') && !sessionStorage.getItem('isSkipSelect')) {
      const acctData = JSON.parse(sessionStorage.getItem('acctData') || '{}')
      if (acctData.email) {
        this.toNext('EMAIL')
      } else if (acctData.phone) {
        this.toNext('PHONE')
      }
      sessionStorage.setItem('isSkipSelect', 'true')
    }
  },
  mounted() {
    // 曝光埋点
    postReportLog({
      log_id: '440',
      extra: {
        page: 'before_login'
      }
    })
    // 女用户提现流程数据埋点
    postReportLog({
      log_id: '477',
      extra: {
        step: '1'
      }
    })
    this.curLanguage = localStorage.getItem('language') || 'en'
    this.lastLoginType = localStorage.getItem('lastLoginType')
    if (this.lastLoginType === 'PHONE') {
      this.moreOptions()
    }
  },
  computed: {
    languageNameLocal() {
      const curLanguageItem = this.languageList.find((item) => item.languageNo === this.curLanguage)
      if (curLanguageItem) {
        return curLanguageItem.languageNameLocal
      } else {
        return ''
      }
    }
  },
  methods: {
    openLanguagePopup() {
      this.showLanguagePopup = true
    },
    closeLanguagePopup() {
      this.showLanguagePopup = false
    },
    changeLanguage(languageNo) {
      this.curLanguage = languageNo
    },
    moreOptions() {
      this.moreOptionsShow = false
      this.phoneShow = true
    },
    toNext(loginType) {
      if (!this.license) {
        Toast(this.$t('loginAndRegister.notAgreeToast'))
        return
      }
      // 绑定钱包流程埋点 - step2 点击绑定方式
      postReportLog({
        log_id: '477',
        extra: {
          step: '2',
          bind_type: loginType === 'EMAIL' ? 'email' : 'phone' // 绑定方式
        }
      })
      this.$router.push({
        name: 'inputAccount',
        query: { loginType }
      })
    },
    checkBoxChange(value) {
      this.license = value
    },
    toProtocolPage() {
      this.$router.push({
        name: 'Protocol',
        params: {
          page: 1
        }
      })
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background: linear-gradient(180deg, #d9ffe8 0.35%, #fff 52.27%);
  box-sizing: border-box;
}

.top_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

.welcome_title {
  position: absolute;
  left: 0;
  height: 0.92rem;
  z-index: 3;
}

.bottom_bg_left {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 2.43rem;
  z-index: 3;
}

.bottom_bg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 84%;
  overflow: hidden;
  object-fit: cover;
  object-position: top;
  z-index: 2;
}

.language_box {
  position: absolute;
  right: 0.2rem;
  display: flex;
  height: 0.3rem;
  padding: 0 0.1rem;
  justify-content: center;
  align-items: center;
  border-radius: 0.08rem;
  border: 0.01rem solid #3fbb70;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  z-index: 2;
}

.unfold_icon {
  width: 0.08rem;
  height: 0.08rem;
  margin-inline-start: 0.03rem;
}

.bottom_btn_group {
  position: absolute;
  bottom: 7%;
  left: 0;
  width: 100%;
  z-index: 4;
}

.to_input_account_btn {
  position: relative;
  display: flex;
  height: 0.48rem;
  padding: 0.12rem 0.1rem;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  border-radius: 0.08rem;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%), rgba(0, 0, 0, 0.9);
  margin: 0 0.48rem 0.24rem;
}

.last_login_label {
  position: absolute;
  right: 0;
  bottom: 0.33rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.02rem;
  background: #ffc714;
  display: flex;
  height: 0.3rem;
  padding: 0 0.12rem;
  justify-content: center;
  align-items: center;
}

.last_login_label.mirror {
  border-radius: 0.08rem 0.08rem 0.02rem 0.08rem;
  left: 0;
  right: auto;
}

.more_options {
  display: flex;
  height: 0.48rem;
  padding: 0.12rem 0.1rem;
  justify-content: center;
  align-items: center;
  line-height: 0.22rem;
  font-weight: 600;
  font-size: 0.14rem;
  position: relative;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-style: normal;
  margin: 0 0.48rem 0.24rem;
}

.to_input_account_btn img {
  width: 0.18rem;
  height: 0.18rem;
  margin-inline-end: 0.06rem;
}

.login_pri {
  font-size: 0.12rem;
  font-family: 'PingFang SC';
  font-weight: 400;
  color: #5b5b5b;
  margin-top: 0.2rem;
  line-height: 0.12rem;
  position: relative;
}

.login_pri_info {
  max-width: 80%;
}

.green {
  color: #3fbb70;
}
</style>



// WEBPACK FOOTER //
// src/views/beforeLogin.vue